import { radialColor, green_colors, red_colors, neutral_colors, getPlatformColorCode } from "../components/MainContent/Dashboard/Charts/utils";
import {
    formatProductAttributeShareOfVoiceData,
    // getCorrectedDate,
    formatConversationOvertimeWithAVGChart,
    formatTopicEngagementOverTime,
    // formatChannelAnalysis,
    formatChannelAnalysisEngagementWise,
    formatOverallShareOfVoiceData,
} from "./dashboardActionUtils";

export const formatInsightsChartData = (resp) => {
    switch (resp.chart_name) {
        case "ocrWordcloud": {
            let data = resp.response;
            let dataRender = [];

            data.aggregations &&
                data.aggregations.wordcloud.buckets &&
                data.aggregations.wordcloud.buckets.map((item, i) => {
                    dataRender.push({
                        name: item.key.toUpperCase(),
                        weight: item.doc_count,
                        color: i > 30 ? "#9BE1FF" : i > 10 ? "#2E5CCF" : "#8334A3",
                        className: null,
                        ocrName: item.key,
                    });
                });
            return dataRender.slice(0, 50);
        }
        case "top-topics": {
            let formattedData = [];
            let options = {};
            let data = resp.response;
            let params = {};

            formattedData = data.aggregations.by_cluster_categories_l2.buckets
                .filter((b) => b.id !== "cluster_319")
                .map((bucket) => {
                    let x = getIndividualBuckets(bucket, options);
                    if (bucket.by_cluster_categories_l3?.buckets?.length > 0)
                        x.drilldown = bucket.by_cluster_categories_l3.buckets?.map((category) => {
                            let y = getIndividualBuckets(category, x);
                            y.drilldown = distinctKeys(category.by_keyword_ner_l3.buckets.map((keyword) => getIndividualBuckets(keyword, y)));
                            return y;
                        });
                    else x.drilldown = distinctKeys(bucket.by_keyword_ner_l2.buckets.map((keyword) => getIndividualBuckets(keyword, x)));

                    return x;
                });

            let { formatted_data, showMoreData, total_value } = formatTopicData(formattedData, params);
            // console.log("donee", formatted_data, showMoreData, total_value);

            return { data: formattedData, formatted_data: formatted_data, showMoreData, total_value };
        }
        case "product-attributes": {
            let res = formatProductAttributeShareOfVoiceData(resp.response, resp.params?.data, resp.params.topicsObject);
            // console.log("ressssssss", res);
            return res;
        }
        case "top-influencers": {
            // let res = formatProductAttributeShareOfVoiceData(resp.response, resp.params?.data, resp.params.topicsObject);
            return resp.response;
        }

        case "overall-summary": {
            let res = formatConversationOvertimeWithAVGChart(resp.response, resp.params?.data);
            return res;
        }
        case "brand-comparision": {
            // let res = formatTopicEngagementOverTime(resp.response, resp.params?.data, resp.params.topicsObject);
            let res = formatOverallShareOfVoiceData(resp.response, resp.params?.data, resp.params.topicsObject);
            return res;
        }
        case "platform-summary": {
            let res = formatChannelAnalysisEngagementWise(resp.response);
            return res;
        }

        default:
            break;
    }
};

export const formatTopicData = (data, params = {}) => {
    data = data.map((bkt) => {
        let x = bkt;
        x.drilldown = bkt.drilldown ? bkt.drilldown : [];
        return x;
    });

    let topTenData = data.slice(0, 10);
    let total_value = 0;

    let formatted_data = [];

    const addDrillDownNodes = (parentNode, level, allArray) => {
        let drillArr = parentNode.drilldown;

        drillArr.forEach((g) => {
            const y = { ...g };
            y.parent = parentNode.id;
            y.level = level;
            y.net_sentiment_score = Math.floor(g.net_sentiment_score);
            y.hexColor = getGroupColour(y.net_sentiment_score, params.sentiment);
            y.color = radialColor(y.hexColor);
            // y.value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? g.traction : g.impact_score) : g.doc_count;
            y.value = g.doc_count;
            total_value += y.value;
            delete y.drilldown;
            if (g.drilldown) {
                y.type = "cluster";
                addDrillDownNodes(g, level + 1, allArray);
            } else y.type = "keyword";
            allArray.push(y);
        });
    };

    topTenData.forEach((d) => {
        const x = { ...d };
        delete x.drilldown;
        x.level = 1;
        x.type = "cluster";

        x.net_sentiment_score = Math.floor(d.net_sentiment_score);

        x.hexColor = getGroupColour(x.net_sentiment_score, params.sentiment);

        x.color = radialColor(x.hexColor);

        x.value = d.doc_count;
        total_value += x.value;
        formatted_data.push(x);

        addDrillDownNodes(d, 2, formatted_data);
    });

    let showMoreData = [];

    if (data.length > 10) {
        showMoreData = JSON.parse(JSON.stringify(formatted_data));

        let doc_count = 0,
            impact_score = 0,
            negative_percentage = 0,
            net_sentiment_score = 0,
            neutral_percentage = 0,
            positive_percentage = 0,
            traction = 0,
            weight = 0,
            count = 0;
        data.slice(10, data.length).forEach((d) => {
            const x = { ...d };
            delete x.drilldown;
            x.level = 1;
            x.parent = "others";
            x.type = "cluster";
            x.net_sentiment_score = Math.floor(d.net_sentiment_score);
            x.hexColor = getGroupColour(x.net_sentiment_score, params.sentiment);
            x.color = radialColor(x.hexColor);
            // x.value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? d.traction : d.impact_score) : d.doc_count;
            x.value = d.doc_count;
            total_value += x.value;
            showMoreData.push(x);
            doc_count += x.doc_count;
            impact_score += x.impact_score;
            negative_percentage += x.negative_percentage;
            net_sentiment_score += x.net_sentiment_score;
            neutral_percentage += x.neutral_percentage;
            positive_percentage += x.positive_percentage;
            traction += x.traction;
            weight += x.weight;
            count++;
            addDrillDownNodes(d, 2, showMoreData);
        });

        negative_percentage /= count;
        net_sentiment_score /= count;
        neutral_percentage /= count;
        positive_percentage /= count;
        const hexColor = getGroupColour(net_sentiment_score, params.sentiment);
        // let value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? traction : impact_score) : doc_count;
        let value = doc_count;
        total_value += value;
        showMoreData.push({
            name: "Others",
            label: "Others",
            id: "others",
            level: "others",
            doc_count,
            impact_score,
            negative_percentage: Math.floor(net_sentiment_score),
            net_sentiment_score,
            neutral_percentage,
            positive_percentage,
            traction,
            weight,
            hexColor,
            value,
            color: radialColor(hexColor),
        });
    }

    return { formatted_data, showMoreData, total_value };
};

const getIndividualBuckets = (bucket, options) => {
    let data = {
        label: bucket.key,
        name: bucket.key,
        doc_count: bucket.doc_count,
        id: bucket.id ? bucket.id : options.id + "_" + bucket.key,
        traction: bucket.by_velocity ? bucket.by_velocity.value : 0,
        impact_score: bucket.by_impact_value ? bucket.by_impact_value.value : 0,
        weight: bucket.doc_count,
    };

    if (bucket.by_sentiments_total) {
        let { negative, positive, neutral, net_sentiment_score } = getBucketSentiment(bucket);
        data.negative_percentage = +negative;
        data.positive_percentage = +positive;
        data.neutral_percentage = +neutral;
        data.net_sentiment_score = +net_sentiment_score;
    } else if (bucket.by_sentiment) {
        data.negative_percentage = bucket.by_sentiment.negative_percentage ? +bucket.by_sentiment.negative_percentage : 0;
        data.positive_percentage = bucket.by_sentiment.positive_percentage ? +bucket.by_sentiment.positive_percentage : 0;
        data.neutral_percentage = bucket.by_sentiment.neutral_percentage ? +bucket.by_sentiment.neutral_percentage : 0;
        data.net_sentiment_score = +bucket.by_sentiment.net_sentiment_score;
    }

    return data;
};

function getGroupColour(net_score, sentiment) {
    if (net_score >= -2 && net_score <= 2) {
        return neutral_colors;
    } else if (net_score < -2) {
        let net_score_adjusted = Math.abs(Math.floor(net_score / 10));
        if (net_score_adjusted >= 4) {
            return red_colors[4];
        } else {
            return red_colors[net_score_adjusted];
        }
    } else {
        let net_score_adjusted = Math.floor(net_score / 10);
        if (sentiment === "negative") {
            if (net_score_adjusted >= 4) {
                return red_colors[4];
            } else {
                return red_colors[net_score_adjusted];
            }
        } else {
            if (net_score_adjusted >= 4) {
                return green_colors[4];
            } else {
                return green_colors[net_score_adjusted];
            }
        }
    }
}

// const green_colors = ["#b7d8a9", "#6aa84f", "#569d00", "#37761c", "#274e11"];
// const red_colors = ["#e6b8af", "#de7e6b", "#cc412b", "#a62420", "#7a0400"];
// const neutral_colors = "#959595";

const distinctKeys = (drillArr) => {
    let distinctKeys = {};

    drillArr.forEach((g) => {
        let distk = g.name.toLowerCase();
        if (distinctKeys[distk]) {
            distinctKeys[distk].doc_count += g.doc_count;
            distinctKeys[distk].traction += g.traction;
            distinctKeys[distk].impact_score += g.impact_score;
            distinctKeys[distk].weight += g.weight;
            distinctKeys[distk].negative_percentage += g.negative_percentage;
            distinctKeys[distk].negative_percentage /= 2;
            distinctKeys[distk].positive_percentage += g.positive_percentage;
            distinctKeys[distk].positive_percentage /= 2;
            distinctKeys[distk].neutral_percentage += g.neutral_percentage;
            distinctKeys[distk].neutral_percentage /= 2;
            distinctKeys[distk].net_sentiment_score = distinctKeys[distk].positive_percentage - distinctKeys[distk].negative_percentage;
            distinctKeys[distk].keywords.push(g.name);
        } else {
            distinctKeys[distk] = g;
            distinctKeys[distk].keywords = [g.name];
        }
    });

    return Object.values(distinctKeys);
};

const getBucketSentiment = (bucket) => {
    let doc_count = bucket.doc_count;

    let sentiment = {
        positive: 0,
        negative: 0,
        neutral: 0,
    };

    bucket.by_sentiments_total.group1.by_sentiments_category.buckets.forEach((s) => {
        sentiment[s.key] = ((s.doc_count * 100) / doc_count).toFixed(2);
    });

    let net_sentiment_score = sentiment.positive - sentiment.negative;

    return { ...sentiment, net_sentiment_score };
};
